import { StreamingPlayerTypography } from '@heardis/stream-contracts';
import RichText from '../../../RichText/RichText';
import classes from './Description.module.css';

type DescriptionProps = {
  content: string;
  typography: StreamingPlayerTypography;
};

function Description({ content, typography }: DescriptionProps): JSX.Element {
  const { fontFamily, fontSize, fontWeight, color } = typography;

  return (
    <article className={classes.description} style={{ fontFamily, fontSize, fontWeight, color }}>
      {content ? <RichText html={content} /> : <p>No description provided.</p>}
    </article>
  );
}

export default Description;
